import * as React from 'react';

function SvgIconTags(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.55 12.349l5.91-5.911a.124.124 0 00.035-.099l-.398-4.71a.25.25 0 00-.228-.227l-4.71-.397a.122.122 0 00-.098.036L2.15 6.95a.125.125 0 000 .176l5.222 5.222c.049.05.129.05.177 0zm1.917-8.335a.752.752 0 011.061 0 .752.752 0 010 1.061.752.752 0 01-1.06 0 .752.752 0 010-1.06zm4.435 4.42l-.62-.617a.125.125 0 00-.176 0L7.45 13.463 3.738 9.76a.125.125 0 00-.177 0l-.619.617a.126.126 0 000 .176l3.8 3.794.619.617a.125.125 0 00.177 0l6.364-6.353a.125.125 0 000-.176z"
        fill="#FCCE01"
      />
    </svg>
  );
}

export default SvgIconTags;
